module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Applications_01-3d01dbe49712dd843879088a31406acf.jpg";